import proxyAddWidgetToParentContext from '../utils/helpers/proxy-add-widget-to-parent-context';

const addWidgetHandler = (e) => {
  proxyAddWidgetToParentContext(e);
};

export default addWidgetHandler;
